import { Modal, Form, Input, Select, message } from "antd";
import { ExpenseUnit } from "@/types/expenseUnit";
import { useUpdateExpenseUnit } from "@/pages/Expenses/ManageExpense/hooks/useExpenseUnits";
import { useEffect } from "react";
import { UpdateExpenseUnitFormValues } from "@/pages/Expenses/ManageExpense/api/expenseUnits";
import { UNIT_TYPE_OPTIONS } from "@/constants/expenseUnit";

interface EditModalProps {
  data?: ExpenseUnit;
  isOpen?: boolean;
  onClose?: () => void;
  onSuccess?: () => void;
}

const EditModal = ({ data, isOpen, onClose, onSuccess }: EditModalProps) => {
  const [form] = Form.useForm();
  const { mutate: updateExpenseUnit, isPending } = useUpdateExpenseUnit();

  const handleSubmit = async (values: UpdateExpenseUnitFormValues) => {
    const payload: UpdateExpenseUnitFormValues = {
      ...values,
      id: data?.id || "",
    };

    updateExpenseUnit(payload, {
      onSuccess: () => {
        message.success("Successfully updated expense unit");
        form.resetFields();
        onClose?.();
        onSuccess?.();
      },
    });
  };

  const handleCancel = () => {
    form.resetFields();
    onClose?.();
  };

  useEffect(() => {
    if (!isOpen) {
      form.resetFields();
    }
  }, [isOpen, form]);

  useEffect(() => {
    if (!data) {
      return;
    }

    form.setFieldsValue(data);
  }, [data, form]);

  return (
    <Modal
      title="Edit Unit"
      open={isOpen}
      onCancel={handleCancel}
      width={600}
      confirmLoading={isPending}
      onOk={form.submit}
      okText="Update"
      destroyOnHidden
    >
      <Form<UpdateExpenseUnitFormValues>
        form={form}
        onFinish={handleSubmit}
        layout="vertical"
        initialValues={
          data && {
            name: data.name,
            symbol: data.symbol,
            unit_type: data.unit_type,
          }
        }
      >
        <Form.Item name="name" label="Name" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item name="symbol" label="Symbol" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item
          name="unit_type"
          label="Unit Type"
          rules={[{ required: true }]}
        >
          <Select
            placeholder="Select unit type"
            options={UNIT_TYPE_OPTIONS.map((option) => ({
              label: option.label,
              value: option.value,
            }))}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditModal;
